import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { CanActivate, Router } from '@angular/router';
import { map, tap } from 'rxjs/operators';
import { LocalizationService } from '../services/localization/localization.service';
import { StoreService } from '../services/store/store.service';

@Injectable({
  providedIn: 'root'
})
export class CheckoutPayGuard implements CanActivate {
  constructor(
    private afAuth: AngularFireAuth,
    private localizationService: LocalizationService,
    private store: StoreService
  ) {}

  canActivate() {
    if (!this.store.selectedPlan.getValue()) {
      this.localizationService.navigate(['result']);
      return false;
    }

    return this.afAuth.authState.pipe(
      map(user => !!user),
      tap(
        loggedIn =>
          loggedIn || this.localizationService.navigate(['checkout', 'join'])
      )
    );
  }
}
